import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Terminal, Binary, Cpu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const menuItems = [
    { title: t('nav.quantum'), icon: <Logo className="w-5 h-5" />, path: '/quantum-news' },
    { title: t('nav.linux'), icon: <Terminal className="w-5 h-5" />, path: '/linux' },
    { title: t('nav.tech'), icon: <Binary className="w-5 h-5" />, path: '/tech-stack' },
    { title: t('nav.about'), icon: <Cpu className="w-5 h-5" />, path: '/about' },
  ];

  return (
    <nav className="bg-[#232323] text-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <Logo className="h-8 w-8" />
              <span className="text-[#EC6224] font-bold text-xl">QuantumBytz</span>
            </Link>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex md:items-center">
            <div className="flex items-center space-x-4">
              {menuItems.map((item) => (
                <Link
                  key={item.title}
                  to={item.path}
                  className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors
                    ${location.pathname === item.path 
                      ? 'bg-[#EC6224] text-white' 
                      : 'hover:bg-[#EC6224] hover:text-white'}`}
                >
                  {item.icon}
                  <span className="ml-2">{item.title}</span>
                </Link>
              ))}
              <LanguageSwitcher />
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-[#EC6224] focus:outline-none"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {menuItems.map((item) => (
              <Link
                key={item.title}
                to={item.path}
                className={`flex items-center px-3 py-2 rounded-md text-base font-medium transition-colors
                  ${location.pathname === item.path 
                    ? 'bg-[#EC6224] text-white' 
                    : 'hover:bg-[#EC6224] hover:text-white'}`}
                onClick={() => setIsOpen(false)}
              >
                {item.icon}
                <span className="ml-2">{item.title}</span>
              </Link>
            ))}
            <div className="px-3 py-2">
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;